// This is copied from packages/backend/lib/dbt/sync-util.ts:155
export function checkBelowMinimumDbtVersion(
  version: string,
  minimum: string,
): boolean {
  let [major, minor] = version.split(".").map((v) => parseInt(v));
  let [minMajor, minMinor] = minimum.split(".").map((v) => parseInt(v));

  major = major || 0;
  minMajor = minMajor || 0;
  minor = minor || 0;
  minMinor = minMinor || 0;

  return (major === minMajor && minor < minMinor) || major < minMajor;
}
